import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { type TLicenseType, type TOgaStatus } from '../../services/licenseTypeApiService';

import { LicenseTypeNature } from '../../types';

export interface ILicenseTypeState {
  licenseTypes: Record<LicenseTypeNature, { data: TLicenseType[]; loading: boolean; isFetched?: boolean }>;
  ogaStatuses: {
    data: TOgaStatus[];
    loading: boolean;
  };
}

const initialState: ILicenseTypeState = {
  licenseTypes: {
    [LicenseTypeNature.LPCO]: {
      data: [],
      loading: false,
      isFetched: false,
    },
    [LicenseTypeNature.EPHYTO]: {
      data: [],
      loading: false,
      isFetched: false,
    },
  },
  ogaStatuses: {
    data: [],
    loading: false,
  },
};

const licenseTypeSlice = createSlice({
  name: 'licenseType',
  initialState,
  reducers: {
    setLicenseTypes: (
      state,
      {
        payload: { data, licenseTypeNature },
      }: PayloadAction<{ data: TLicenseType[]; licenseTypeNature: LicenseTypeNature }>
    ) => {
      state.licenseTypes[licenseTypeNature].data = data;
      state.licenseTypes[licenseTypeNature].loading = false;
      state.licenseTypes[licenseTypeNature].isFetched = true;
    },
    setLicenseTypesLoading: (
      state,
      {
        payload: { loading, licenseTypeNature },
      }: PayloadAction<{ loading: boolean; licenseTypeNature: LicenseTypeNature }>
    ) => {
      state.licenseTypes[licenseTypeNature].loading = loading;
    },

    resetLicenseTypes: (state, { payload = LicenseTypeNature.LPCO }: PayloadAction<LicenseTypeNature>) => {
      state.licenseTypes[payload].data = [];
      state.licenseTypes[payload].isFetched = false;
    },
    setOgaStatuses: (state, { payload }: PayloadAction<TOgaStatus[]>) => {
      state.ogaStatuses.data = payload;
      state.ogaStatuses.loading = false;
    },
    setOgaStatusesLoading: (state, { payload }: PayloadAction<boolean>) => {
      state.ogaStatuses.loading = payload;
    },
  },
});

export const { setLicenseTypes, setLicenseTypesLoading, setOgaStatuses, setOgaStatusesLoading, resetLicenseTypes } =
  licenseTypeSlice.actions;

export default licenseTypeSlice;
